// extracted by mini-css-extract-plugin
export default {"deleteInvoiceDialog":"PZYcF","submissionMessage":"NFjeP"};